import React, { useEffect, useState } from 'react'
import { Container, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import * as Icon from "react-bootstrap-icons";
import { useNavigate } from 'react-router-dom';
import normal from "../../images/gif/frame-88.png"
import medium from "../../images/gif/Ripple-6.3s-200px.gif";
import immediate from "../../images/gif/Ripple-1s-200px (1).gif"
import Badge from 'react-bootstrap/Badge';
import { getAllSelfTasks, setActiveToggle, setFilterTasksData } from './AllTaskSlice';
import Pagination from './Pagination'
import EditTaskModel from './Model/EditTaskModel';
import DeleteTaskModel from './Model/DeleteTaskModel';
import { CreateSelfTaskModel } from './Model/CreateSelfTaskModel';
import DisplayHoursAndMinutes from './Convertor/DisplayHoursAndMinutes';
import axios from 'axios';
import { toast } from 'react-toastify';
import useGetEmployees from './ReuseApi/useGetEmployees';
import useGetDepartments from './ReuseApi/useGetDepartments';
import useGetSubDepartments from './ReuseApi/useGetSubDepartments';
import { useProjectList } from './ReuseApi/useProjectList ';
import SelfTaskFilter from './Filter/SelfTaskFilter';
import { taskPriorityOptions } from '../utils/constant';
import { AssignAllocatedTaskModel } from './Model/AssignAllocatedTaskModel';
import CompleteTaskModal from './Model/CompleteTaskModal';
import ReopenTaskModal from './Model/ReopenTaskModal';
import DeleteEmployeeSelfTaskModal from './Model/DeleteEmployeeSelfTaskModal';

const SelfAllTask = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const currentToggle = useSelector((state) => state?.AllTasks?.ActiveToggle);
    const filterAllTasks = useSelector((state) => state?.AllTasks?.AllFilterTasksData);
    const loginUserData = useSelector((state) => state.loginData.userData)
    const deptNameArray = (loginUserData?.department).map((itm) => itm.label)
    const allTasks = useSelector(state => state.AllTasks.AllSelfTask)
    const role = loginUserData?.resourceType

    const [show, setShow] = useState(false)
    const [showfilter, setShowFilter] = useState(false)
    const [docsPerPage, setDocsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [item, setItem] = useState();
    const [project, setProject] = useState(null);
    const [department, setDepartment] = useState(null);
    const [subdepartment, setSubDepartment] = useState(null);
    const [priority, setPriority] = useState(null);
    const [category, setCategory] = useState(null);
    const [assignBy, setAssignBy] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [idcMin, setIdcMin] = useState(null);
    const [idcMax, setIdcMax] = useState(null);
    const [qwdMin, setQwdMin] = useState(null);
    const [qwdMax, setQwdMax] = useState(null);
    const [taskId, setTaskId] = useState("")
    const [showAssignModel, setShowAssignModel] = useState(false)
    const [activeTaskId, setActiveTaskId] = useState(null);
    const [taskStatusMap, setTaskStatusMap] = useState({});
    const [timeMap, setTimeMap] = useState({});
    const [showCompleteModal, setShowCompleteModal] = useState(false);
    const [selectedTaskId, setSelectedTaskId] = useState("");
    const [pendingFilterValues, setPendingFilterValues] = useState({});
    const [completedFilterValues, setCompletedFilterValues] = useState({});
    const [showEdit, setShowEdit] = useState(false)
    const [showNoDataFound, setShowNoDataFound] = useState(false);
    const [showReopenModal, setShowReopenModal] = useState(false);
    const [reopenTaskData, setReopenTaskData] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showEmployeeDeleteModal, setShowEmployeeDeleteModal] = useState(false);

    // call custom hook
    const { employeeOptions } = useGetEmployees();
    const { allDepartmentOptionsById } = useGetDepartments();
    const { subDeptOptions } = useGetSubDepartments(department?.value);
    const { projectOptions, departmentOptions } = useProjectList(project?.value);

    const handleOpenReopenModal = (taskData) => {
        setReopenTaskData(taskData);
        setShowReopenModal(true);
    };

    const handleCloseReopenModal = () => {
        setShowReopenModal(false);
        setReopenTaskData(null);
        getAllSelfTaskData();
    };

    const handleShowDeleteModal = (id) => {
        setTaskId(id);

        if (loginUserData?.resourceType === "employee") {
            setShowEmployeeDeleteModal(true);
        } else {
            setShowDeleteModal(true);
        }
    };

    const handleEmployeeDeleteModalClose = () => {
        setShowEmployeeDeleteModal(false);
        setTaskId("");
        getAllSelfTaskData();
    };

    const handleDeleteModalClose = () => {
        setShowDeleteModal(false);
        setTaskId("");
        getAllSelfTaskData();
    };

    const handleShowEditModal = (item) => {
        setItem(item);
        setTaskId(item.taskId);
        setShowEdit(true);
    };

    const deriveStatusFromLog = (task) => {
        const logs = task.taskActionLog || [];

        if (task.status === "completed") return "completed";
        if (task.status === "rejected") return "rejected";

        if (!logs.length) return null;

        const lastAction = logs[logs.length - 1].actionStatus;

        switch (lastAction) {
            case "start":
            case "resume":
                return "running";

            case "pause":
                return "paused";

            case "end":
                return "completed";

            default:
                return null;
        }
    };

    // for filtering data
    const filteredProjectOptions = [
        ...new Map(
            (allTasks?.data || []).map((task) => [
                task.projectName,
                {
                    value: task.projectName,
                    label: task.projectName,
                },
            ])
        ).values(),
    ];

    // data for assign by leadname
    const resultData = Array.isArray(loginUserData.lead_name)
        ? loginUserData.lead_name.map((itm) => ({ value: itm, label: itm }))
        : { value: loginUserData.lead_id, label: loginUserData.lead_name };

    const AssignByOption = resultData

    useEffect(() => {
        getAllSelfTaskData()
    }, [currentPage, docsPerPage, currentToggle])

    // for review modal
    const getAllSelfTaskData = (page = currentPage) => {
        const payload = {
            empId: loginUserData?.empId,
            taskPriority: priority?.value ? priority?.value : "",
            taskName: "",
            departmentName: deptNameArray,
            projectName: project?.label ? project?.label : "",
            subDepartmentId: subdepartment?.value,
            department_id: department?.value,
            categoryOfName: "",
            resource_id: "",
            proposedStartDate: startDate,
            proposedEndDate: endDate,
            status: currentToggle === "pending" ? ["pending", "inProgress"] : currentToggle,
            // status: currentToggle,
            idcMin: idcMin?.value,
            idcMax: idcMax?.value,
            qwdMin: qwdMin?.value,
            qwdMax: qwdMax?.value,
            slippage: "",
            efficiency: "",
            assignBy_Name: assignBy?.label,
            documentsPerPage: docsPerPage,
            page: page
        }

        dispatch(getAllSelfTasks(payload))
    }

    useEffect(() => {
        localStorage.setItem("taskStatusMap", JSON.stringify(taskStatusMap));
    }, [taskStatusMap]);

    useEffect(() => {
        if (allTasks?.data?.length) {
            const newStatusMap = {};
            let runningTask = null;

            allTasks.data.forEach(task => {
                const status = deriveStatusFromLog(task);
                newStatusMap[task.taskId] = status;

                if (status === "running") {
                    runningTask = task.taskId;
                }
            });

            setTaskStatusMap(newStatusMap);
            setActiveTaskId(runningTask);
        }
    }, [allTasks]);

    // CURRENT USER INFO
    const { empId, firstName, lastName } = useSelector(state => state?.loginData?.userData);

    // CONSTANTS
    const actions = {
        START: "start",
        PAUSE: "pause",
        RESUME: "resume",
        END: "end"
    }

    useEffect(() => {
        let interval;

        if (activeTaskId) {
            interval = setInterval(() => {
                setTimeMap((prev) => ({
                    ...prev,
                    [activeTaskId]: (prev[activeTaskId] || 0) + 1,
                }));
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [activeTaskId]);


    const handleStart = async (taskId) => {
        try {
            if (activeTaskId && activeTaskId !== taskId) {
                await axios.post(
                    process.env.REACT_APP_BASE_URL + "/task/taskAction",
                    {
                        taskId: activeTaskId,
                        action: "pause",
                        resource_id: empId,
                        resourceName: `${firstName} ${lastName}`,
                        reason: ""
                    }
                );
            }

            await axios.post(
                process.env.REACT_APP_BASE_URL + "/task/taskAction",
                {
                    taskId: taskId,
                    action: "start",
                    resource_id: empId,
                    resourceName: `${firstName} ${lastName}`,
                    reason: ""
                }
            );

            getAllSelfTaskData();

        } catch (error) {
            toast.error("Error while switching tasks");
        }
    };

    const handlePause = (taskId) => {
        setActiveTaskId(null);
        setTaskStatusMap(prev => ({ ...prev, [taskId]: "paused" }));
    };

    const handleResume = async (taskId) => {
        try {
            if (activeTaskId && activeTaskId !== taskId) {
                await axios.post(
                    process.env.REACT_APP_BASE_URL + "/task/taskAction",
                    {
                        taskId: activeTaskId,
                        action: "pause",
                        resource_id: empId,
                        resourceName: `${firstName} ${lastName}`,
                        reason: ""
                    }
                );
            }

            await axios.post(
                process.env.REACT_APP_BASE_URL + "/task/taskAction",
                {
                    taskId: taskId,
                    action: "start",
                    resource_id: empId,
                    resourceName: `${firstName} ${lastName}`,
                    reason: ""
                }
            );

            getAllSelfTaskData();

        } catch (error) {
            toast.error("Error while resuming task");
        }
    };

    const handleStop = (taskId) => {
        setActiveTaskId(null);
        setTaskStatusMap(prev => ({ ...prev, [taskId]: "completed" }));
    };

    const handleAssignModelOpen = (id) => {
        setTaskId(id);
        setShowAssignModel(true)
    }

    const handleAssignModelClose = (id) => {
        setTaskId(id);
        setShowAssignModel(false)
    }

    const handleOpenCompleteModal = (taskId) => {
        setSelectedTaskId(taskId);
        setShowCompleteModal(true);
    };

    const handleCloseCompleteModal = () => {
        setSelectedTaskId("");
        setShowCompleteModal(false);
    };


    useEffect(() => {
        if (allTasks?.data?.length) {
            const newStatusMap = {};
            let runningTask = null;

            allTasks.data.forEach(task => {
                const status = deriveStatusFromLog(task);
                newStatusMap[task.taskId] = status;

                if (status === "running") {
                    runningTask = task.taskId;
                }
            });

            setTaskStatusMap(newStatusMap);
            setActiveTaskId(runningTask);
        }
    }, [allTasks]);

    // for status toggle change
    const handleToggleChange = (toggleValue) => {
        dispatch(setActiveToggle(toggleValue));
        if (toggleValue === 'pending') {
            setCompletedFilterValues({});
        } else {
            setPendingFilterValues({});
        }
    };

    // function
    const handleCloseCreateModel = () => {
        getAllSelfTaskData()
        setShow(false)
    }

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);

    };

    const handleDocsPerPage = (docsPageProp) => {
        setCurrentPage(1);
        setDocsPerPage(docsPageProp);

    }

    const handleEditModalClose = () => {
        setShowEdit(false)
        setItem("");
        getAllSelfTaskData()
    }

    const handleToggleTimer = async (taskId, curAction, extraData = {}) => {

        const actionsVal = Object.values(actions);
        const action = curAction.toLowerCase();
        const actionInd = actionsVal.indexOf(action);


        try {
            const payload = {
                taskId,
                action: actionsVal[actionInd],
                resource_id: empId,
                resourceName: `${firstName} ${lastName}`,
                reason: '',
                completeRemark: extraData?.remark || "",
                actualHours: Number(extraData?.actualHours || 0),
                actualMinutes: Number(extraData?.actualMinutes || 0),
            }
            const endpoint = '/task/taskAction'
            const res = await axios.post(process.env.REACT_APP_BASE_URL + endpoint, payload);

            if (actionInd === 0) {
                await handleStart(taskId);
                return;
            } else if (actionInd === 1) {
                handlePause(taskId);
                getAllSelfTaskData();
            } else if (actionInd === 2) {
                handleResume(taskId);
                getAllSelfTaskData();
            } else if (actionInd === 3) {
                handleStop(taskId);
                getAllSelfTaskData();
            }

            if (res.status === 200) {
                toast.success(`Task ${actionInd === 0 ? "started" : actionInd === 1 ? "paused" : actionInd === 2 ? "resumed" : "ended"} successfully`);
                if (action === "end") {
                    getAllSelfTaskData();
                }
            } else if (res.status === 400) {
                toast.info('Task Is Already Running', {
                    toastId: "already-running"
                })
            } else {
                toast.error(`Failed to ${action} task`, {
                    toastId: "action-failed"
                });
            }

        } catch (error) {
            toast.error(`Error: ${error.response?.data?.message || error.message}`, {
                toastId: "action-error"
            });
        }
    }

    const handleConfirmComplete = async (payload) => {
        await handleToggleTimer(selectedTaskId, actions.END, payload);

        handleCloseCompleteModal();
    };

    const handleSearch = () => {
        setCurrentPage(1)
        getAllSelfTaskData(1)
    }

    const handleClear = () => {
        setProject(null)
        setDepartment(null)
        setSubDepartment(null)
        setPriority(null)
        setAssignBy(null)
        setStartDate("")
        setEndDate("")
        setIdcMin(null)
        setIdcMax(null)
        setQwdMin(null)
        setQwdMax(null)
        setCurrentPage(1)
        dispatch(getAllSelfTasks({
            empId: loginUserData?.empId,
            taskPriority: "",
            taskName: "",
            departmentName: deptNameArray,
            projectName: "",
            categoryOfName: "",
            resource_id: "",
            proposedStartDate: "",
            proposedEndDate: "",
            subDepartmentId: "",
            department_id: "",
            status: currentToggle,
            idcMin: "",
            idcMax: "",
            qwdMin: "",
            qwdMax: "",
            slippage: "",
            efficiency: "",
            assignBy_Name: "",
            documentsPerPage: docsPerPage,
            page: currentPage
        }))
    }

    return (
        <div className='TLAssignedTask outletPadding' data-aos='fade-up'>
            <Container>
                <SelfTaskFilter
                    projectOptions={filteredProjectOptions}
                    departmentOptions={allDepartmentOptionsById}
                    subdepartmentOptions={subDeptOptions}
                    employeeOptions={AssignByOption}
                    taskPriorityOptions={taskPriorityOptions}
                    idcOptions={[
                        { label: "1", value: "1" },
                        { label: "2", value: "2" },
                        { label: "3", value: "3" },
                        { label: "4", value: "4" },
                        { label: "5", value: "5" },
                        { label: "6", value: "6" },
                        { label: "7", value: "7" },
                        { label: "8", value: "8" },
                        { label: "9", value: "9" },
                        { label: "10", value: "10" },
                    ]}
                    project={project}
                    setProject={setProject}
                    department={department}
                    setDepartment={setDepartment}
                    priority={priority}
                    setPriority={setPriority}
                    subdepartment={subdepartment}
                    setSubDepartment={setSubDepartment}
                    assignBy={assignBy}
                    setAssignBy={setAssignBy}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    idcMin={idcMin}
                    setIdcMin={setIdcMin}
                    idcMax={idcMax}
                    setIdcMax={setIdcMax}
                    qwdMin={qwdMin}
                    setQwdMin={setQwdMin}
                    qwdMax={qwdMax}
                    setQwdMax={setQwdMax}
                    onSubmit={handleSearch}
                    onClear={handleClear}
                    taskStatus={currentToggle}
                    role={role}
                />
                <CompleteTaskModal
                    show={showCompleteModal}
                    close={handleCloseCompleteModal}
                    onSubmit={handleConfirmComplete}
                />
                <AssignAllocatedTaskModel show={showAssignModel} close={handleAssignModelClose} data={taskId} />
                <CreateSelfTaskModel show={show} close={handleCloseCreateModel} userData={loginUserData} />
                <EditTaskModel show={showEdit} close={handleEditModalClose} taskId={taskId} item={item} userData={loginUserData} />
                <DeleteTaskModel show={showDeleteModal} close={handleDeleteModalClose} taskId={taskId} />
                <DeleteEmployeeSelfTaskModal show={showEmployeeDeleteModal} close={handleEmployeeDeleteModalClose} taskId={taskId} />
                <ReopenTaskModal show={showReopenModal} close={handleCloseReopenModal} data={reopenTaskData} />

                <Row className='d-flex justify-content-between align-items-center'>
                    <Col md={6} className="d-flex justify-content-start align-items-center">
                        {/* {loginUserData?.resourceType !== "employee" && */}
                        <Button className="primaryBtn btn-16 me-3" onClick={() => { setShow(true) }}>
                            <Icon.PlusCircle className="me-2" size={16} />
                            Create SelfTask
                        </Button>
                        {/* } */}
                    </Col>
                    <Col sm={12} md={6} className='d-flex justify-content-end align-items-center'>
                        <ButtonGroup aria-label="Basic example">
                            <Button
                                disabled={currentToggle === "pending" ? true : false}
                                variant={currentToggle === 'pending' ? 'warning' : 'outline-warning'}
                                onClick={() => {
                                    handleToggleChange('pending'); dispatch(setFilterTasksData([])); setShowNoDataFound(false); handleDocsPerPage(10)
                                }}
                            >
                                Pending
                            </Button>
                            <Button
                                disabled={currentToggle === "completed" ? true : false}
                                variant={currentToggle === 'completed' ? 'success' : 'outline-success'}
                                onClick={() => { handleToggleChange('completed'); dispatch(setFilterTasksData([])); setShowNoDataFound(false); handleDocsPerPage(10) }}
                            >
                                Completed
                            </Button>
                            <Button
                                disabled={currentToggle === "rejected" ? true : false}
                                variant={currentToggle === 'rejected' ? 'danger' : 'outline-danger'}
                                onClick={() => { handleToggleChange('rejected'); dispatch(setFilterTasksData([])); setShowNoDataFound(false); handleDocsPerPage(10) }}
                            >
                                Rejected
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                <div className='outer-wrapper mx-auto'>
                    <div className='table-wrapper'>
                        <table>
                            <thead>
                                <tr className='tbl-header'>
                                    <th>Priority</th>
                                    {currentToggle === "pending" &&
                                        <th>Due(Days)</th>}
                                    <th>Project</th>
                                    <th className='taskwidth'>Task Name</th>
                                    <th>Task Description</th>
                                    {/* <th className="max-width-th">Category</th> */}
                                    <th className='assignwidth'>Assign By</th>
                                    <th>Task Priority</th>
                                    <th>Date</th>
                                    <th>Initial Hr</th>
                                    {
                                        currentToggle === "completed" &&
                                        <>
                                            <th>Actual Hr</th>
                                            <th>IDC</th>
                                            <th>QWD</th>
                                            <th>Slippage</th>
                                            <th>Efficiency</th>

                                        </>
                                    }
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {filterAllTasks?.data?.length > 0 || !showNoDataFound ? (
                                // filterAllTasks
                                <tbody>
                                    {
                                        allTasks?.data !== null &&
                                            allTasks?.data !== undefined &&
                                            allTasks?.data?.length > 0 ? (
                                            (filterAllTasks?.data?.length > 0 ? filterAllTasks?.data : allTasks?.data
                                            ).map((itm) => {
                                                const { taskName, taskPriority, taskDescription, departmentName, taskDepartmentName, categoryOfName, assignBy_Name, resourceName, proposedStartDate,
                                                    proposedEndDate, status, idc, qwd, slippage, efficiency, taskId, isAccepted, isRejected,
                                                    initialEstimateHr, actualHours, isTaskAssigned, isheadTask, isSelfTaskAssigned, isAssignedTask, isReassignedTask, otherProjectName,
                                                    projectName } = itm
                                                const isReassigned = itm?.reassignedStatus === "reassignedToOther";

                                                // for convert hours and minute
                                                const parts = initialEstimateHr?.toFixed(2).toString().split(".") || [];
                                                const integerPart = parseInt(parts[0]);
                                                const decimalPart = parseInt(parts[1]);
                                                const hours = integerPart;
                                                const minutes = Math.round((decimalPart / 100) * 60);

                                                // for due days
                                                const currentDate = new Date();
                                                const endDate = new Date(itm.proposedEndDate);
                                                const endTimestamp = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
                                                const currentTimestamp = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

                                                const currentStatus =
                                                    taskStatusMap[itm.taskId] ??
                                                    status ??
                                                    "pending";

                                                // for next date disable
                                                const today = new Date();
                                                today.setHours(0, 0, 0, 0);

                                                const taskStartDate = new Date(itm.proposedStartDate);
                                                taskStartDate.setHours(0, 0, 0, 0);

                                                const canStartTask = taskStartDate <= today;

                                                let daysDifference = 0;
                                                if (currentTimestamp > endTimestamp) {
                                                    const differenceMillis = Math.abs(currentTimestamp - endTimestamp);
                                                    daysDifference = Math.ceil(differenceMillis / (1000 * 60 * 60 * 24));
                                                }
                                                const isForceShow = isAssignedTask && isReassignedTask && !isheadTask;
                                                const hideForHeadReassignedTask =
                                                    isheadTask === true &&
                                                    isAssignedTask === true &&
                                                    isReassignedTask === true;

                                                const showPlay =
                                                    loginUserData?.resourceType === "employee"
                                                        ? true
                                                        : (
                                                            !hideForHeadReassignedTask &&
                                                            !isReassigned &&
                                                            (
                                                                isSelfTaskAssigned === true ||
                                                                (
                                                                    isTaskAssigned === true &&
                                                                    isheadTask === false &&
                                                                    isAssignedTask === false
                                                                )
                                                            )
                                                        );

                                                const showAssign =
                                                    isTaskAssigned === true &&
                                                    isheadTask === false &&
                                                    !isReassigned &&
                                                    currentStatus !== "running" &&
                                                    currentStatus !== "paused" &&
                                                    currentStatus !== "completed";

                                                // const showAssign =
                                                //     !hideForHeadReassignedTask &&
                                                //     (
                                                //         (
                                                //             isTaskAssigned === true &&
                                                //             isheadTask === false &&
                                                //             !isReassigned &&
                                                //             currentStatus !== "running" &&
                                                //             currentStatus !== "paused" &&
                                                //             currentStatus !== "completed"
                                                //         )
                                                //         ||
                                                //         (
                                                //             isAssignedTask === true &&
                                                //             isReassignedTask === true
                                                //         )
                                                //     );

                                                const showAssigned = isReassigned;
                                                return (
                                                    <tr key={Math.random() * 999999999}>
                                                        <td>
                                                            {taskPriority === "low" ?
                                                                <img width={50} height={50} src={normal} data-toggle="tooltip" title="Low" />
                                                                :
                                                                taskPriority === "medium"
                                                                    ?
                                                                    <img width={50} height={50} src={medium} data-toggle="tooltip" title="Medium" />
                                                                    :
                                                                    (taskPriority === "urgent" || taskPriority === "high")
                                                                        ?
                                                                        <img width={50} height={50} src={immediate} data-toggle="tooltip" title="Urgent" />
                                                                        : ''
                                                            }
                                                        </td>
                                                        {currentToggle === "pending" &&
                                                            <td>
                                                                <div className={`circle ${daysDifference < 5 ? 'green' : daysDifference < 15 ? 'orange' : 'red'}`} style={{ height: '35px', width: '35px', borderRadius: '55%', margin: 'auto' }}>
                                                                    <span className="number">{Math.floor(daysDifference)}</span>
                                                                </div>
                                                            </td>
                                                        }
                                                        <td>
                                                            {projectName === "Other"
                                                                ? otherProjectName
                                                                : projectName}
                                                        </td>
                                                        <td>{taskName}</td>
                                                        <td
                                                            style={{
                                                                maxWidth: "400px",
                                                                whiteSpace: "normal",
                                                                wordBreak: "break-word",
                                                            }}
                                                        >
                                                            {taskDescription}
                                                        </td>
                                                        {/* <td>{taskDescription}</td> */}
                                                        {/* <td>{categoryOfName}</td> */}
                                                        <td>{assignBy_Name}</td>
                                                        <td>{taskPriority}</td>
                                                        <td>
                                                            {new Date(
                                                                proposedStartDate
                                                            ).toLocaleDateString("en-US", {
                                                                month: "long",
                                                                year: "numeric",
                                                            }) ==
                                                                new Date(proposedEndDate).toLocaleDateString("en-US", { month: "long", year: "numeric" })
                                                                ? `${new Date(
                                                                    proposedStartDate
                                                                ).getDate()} - ${new Date(
                                                                    proposedEndDate
                                                                ).getDate()} ${new Date(
                                                                    proposedStartDate
                                                                ).toLocaleDateString("en-US", {
                                                                    month: "long",
                                                                    year: "numeric",
                                                                })}`
                                                                : `${new Date(
                                                                    proposedStartDate
                                                                ).getDate()} ${new Date(
                                                                    proposedStartDate
                                                                ).toLocaleDateString("en-US", {
                                                                    month: "long",
                                                                    year: "numeric",
                                                                })} -  ${new Date(
                                                                    proposedEndDate
                                                                ).getDate()} ${new Date(
                                                                    proposedEndDate
                                                                ).toLocaleDateString("en-US", {
                                                                    month: "long",
                                                                    year: "numeric",
                                                                })}`}
                                                        </td>
                                                        {/* <td>{initialEstimateHr ? initialEstimateHr.toFixed(2)  : 0}</td> */}
                                                        {/* <td>{`${hours} hr ${minutes} min`}</td> */}
                                                        <td><DisplayHoursAndMinutes value={initialEstimateHr} /></td>

                                                        {
                                                            currentToggle === "completed" &&
                                                            <>
                                                                <td> <DisplayHoursAndMinutes value={actualHours} /></td>
                                                                {/* <td>{actualHours ? actualHours.toFixed(2)  : 0}</td> */}
                                                                <td>{idc !== null && idc !== undefined ? idc.toFixed(2) : 0}</td>
                                                                <td>{qwd !== null && qwd !== undefined ? qwd.toFixed(2) : 0}</td>
                                                                <td>{slippage !== null && slippage !== undefined ? slippage.toFixed(2) : 0}</td>
                                                                <td>{efficiency !== null && efficiency !== undefined ? efficiency.toFixed(2) : 0}</td>
                                                            </>
                                                        }

                                                        <td className='text-capitalize'>
                                                            <Badge bg={status === "completed" ? "success p-1 text-white" : "warning text-dark p-1"}>{currentStatus === "running" ? "In Progress" : currentStatus}</Badge>
                                                        </td>

                                                        <td>
                                                            <span data-toggle="tooltip" title="view" className="d-flex align-items-center gap-2">
                                                                <Icon.Eye size={22} className='me-2' onClick={() => {
                                                                    navigate(`/${loginUserData?.resourceType}/self-task/view-details`, {
                                                                        state: { data: itm }
                                                                    })
                                                                }}
                                                                />

                                                                {/* {currentToggle === "pending" && isSelfTaskAssigned === true && ( */}
                                                                {currentToggle === "pending" &&
                                                                    isSelfTaskAssigned &&
                                                                    !["running", "paused"].includes(currentStatus) && (
                                                                        <>
                                                                            <Icon.PencilSquare
                                                                                size={20}
                                                                                className="cursor-pointer"
                                                                                title="Edit"
                                                                                onClick={() => handleShowEditModal(itm)}
                                                                            />

                                                                            <Icon.Trash
                                                                                size={20}
                                                                                color="red"
                                                                                className="cursor-pointer"
                                                                                title="Delete"
                                                                                onClick={() => handleShowDeleteModal(itm.taskId)}
                                                                            />
                                                                        </>
                                                                    )}

                                                                {(showPlay || isForceShow) && !(loginUserData?.resourceType === "employee" && currentToggle === "completed") && (
                                                                    <>
                                                                        {currentStatus === "completed" ? (
                                                                            <Button
                                                                                size="sm"
                                                                                className="d-flex align-items-center gap-1"
                                                                                style={{
                                                                                    backgroundColor: "#198754",
                                                                                    border: "none",
                                                                                    borderRadius: "20px",
                                                                                    padding: "5px 12px",
                                                                                    fontSize: "12px",
                                                                                    fontWeight: "600",
                                                                                }}
                                                                                onClick={() => {
                                                                                    handleOpenReopenModal(itm);
                                                                                }}
                                                                            >
                                                                                <Icon.ArrowRepeat size={14} />
                                                                                Reopen
                                                                            </Button>
                                                                        ) : currentStatus === "running" ? (
                                                                            <>
                                                                                <Icon.PauseFill
                                                                                    size={20}
                                                                                    color="orange"
                                                                                    className="cursor-pointer"
                                                                                    title="Pause"
                                                                                    onClick={() => handleToggleTimer(itm.taskId, actions.PAUSE)}
                                                                                />
                                                                                <Icon.StopFill
                                                                                    size={20}
                                                                                    color="red"
                                                                                    className="cursor-pointer"
                                                                                    title="Complete"
                                                                                    onClick={() => handleOpenCompleteModal(itm.taskId)}
                                                                                // onClick={() => handleToggleTimer(itm.taskId, actions.END)}
                                                                                />
                                                                            </>
                                                                        ) : currentStatus === "paused" ? (
                                                                            <>
                                                                                <Icon.PlayFill
                                                                                    size={20}
                                                                                    color="blue"
                                                                                    className="cursor-pointer"
                                                                                    title="Resume"
                                                                                    onClick={() => handleToggleTimer(itm.taskId, actions.RESUME)}
                                                                                />
                                                                                <Icon.StopFill
                                                                                    size={20}
                                                                                    color="red"
                                                                                    className="cursor-pointer"
                                                                                    title="Stop"
                                                                                    onClick={() => handleOpenCompleteModal(itm.taskId)}
                                                                                // onClick={() => handleToggleTimer(itm.taskId, actions.END)}
                                                                                />
                                                                            </>
                                                                        ) : (
                                                                            <Icon.PlayFill
                                                                                size={20}
                                                                                color={canStartTask ? "green" : "gray"}
                                                                                className={canStartTask ? "cursor-pointer" : "disabled"}
                                                                                title={
                                                                                    canStartTask
                                                                                        ? "Start"
                                                                                        : `Task can start on ${new Date(
                                                                                            itm.proposedStartDate
                                                                                        ).toLocaleDateString()}`
                                                                                }
                                                                                onClick={() => {
                                                                                    if (canStartTask) {
                                                                                        handleToggleTimer(itm.taskId, actions.START);
                                                                                    }
                                                                                }}
                                                                                style={{
                                                                                    opacity: canStartTask ? 1 : 0.4,
                                                                                    pointerEvents: canStartTask ? "auto" : "none",
                                                                                }}
                                                                            />
                                                                            // <Icon.PlayFill
                                                                            //     size={20}
                                                                            //     color="green"
                                                                            //     className="cursor-pointer"
                                                                            //     title="Start"
                                                                            //     onClick={() => handleToggleTimer(itm.taskId, actions.START)}
                                                                            // />
                                                                        )}
                                                                    </>
                                                                )}
                                                                {loginUserData?.resourceType !== "employee" && (
                                                                    <>
                                                                        {showAssigned ? (
                                                                            <span
                                                                                data-toggle="tooltip"
                                                                                title="Assigned"
                                                                                style={{
                                                                                    color: "green",
                                                                                    fontSize: "25px"
                                                                                }}
                                                                            >
                                                                                <Icon.PersonCheckFill />
                                                                            </span>
                                                                        ) : showAssign ? (
                                                                            <span
                                                                                data-toggle="tooltip"
                                                                                title="Assign"
                                                                                style={{
                                                                                    color: "#000000",
                                                                                    fontSize: "25px"
                                                                                }}
                                                                            >
                                                                                <Icon.PersonAdd
                                                                                    onClick={() =>
                                                                                        handleAssignModelOpen(itm)
                                                                                    }
                                                                                />
                                                                            </span>
                                                                        ) : null}
                                                                    </>
                                                                )}
                                                            </span>

                                                        </td>

                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="18" className="text-center">No data available</td>
                                            </tr>
                                        )}
                                </tbody>
                            )
                                :
                                <tr>
                                    <td colSpan="18" className="text-center">No Task Available</td>
                                </tr>
                            }
                        </table>
                    </div>
                </div>

                {allTasks?.data !== null || allTasks?.data?.length > 0 && filterAllTasks?.data?.length > 0 || !showNoDataFound ? (
                    <div className='pagination-wrapper p-0'>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={filterAllTasks?.data?.length > 0 ? filterAllTasks?.noOfPages : allTasks?.noOfPages}
                            onPageChange={handlePageChange}
                            onDocsPerPage={handleDocsPerPage}
                            docsPerPage={docsPerPage}
                        />
                    </div>
                ) : (
                    ''
                )}

            </Container>
        </div>
    )
}

export default SelfAllTask;